<template>
  <div class="othersolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>曾经，典型的合同签署流程是这样的……</li>
              </ul>
            </div>
            <div class="othersItem">
                <ul>
                  <li v-for="(item,index) in everList" :key="index">
                    <span>{{index+1}}</span>
                    <p>{{item}}</p>
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <div class="solttionConB">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>有一些小缺点……</li>
              </ul>
            </div>
            <div class="deficiencyBox">
              <ul>
                <li v-for="item in deficiencyList">
                  <img :src="item.img">
                  <p>{{item.name}}</p>
                </li>
              </ul>
              <div class="title">
                传统纸质合同的高成本以及低效率，让我们寻求改进，后来，我们采用了电子化文档管理以及签署电子协议……
              </div>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>特点是……</li>
              </ul>
            </div>
            <div class="deficiencyBox">
              <ul>
                <li v-for="item in deficiencyLists">
                  <img :src="item.img">
                  <p>{{item.name}}</p>
                </li>
              </ul>
              <div class="title">
                传统电子文档管理及电子协议存在着不被法律认可、容易丢失、无可信时间、无法追溯、容易被篡改等一系列风险。
              </div>
            </div>
          </div>
        </div>
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>智签电子签约平台，可以更好的满足不同行业的签约需求：</li>
              </ul>
            </div>
            <div class="signItem">
                <ul v-if="signList.length>0">
                  <li v-for="(item,index) in signList" :key="index">
                    <img :src="item.img">
                    <p>{{item.name}}</p>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConHead solttionConHeads" style="padding-top:0;">
              <ul>
                <li></li>
                <li>有需要签字的地方，就有智签，以下行业，可现在点击<router-link  to="/verification/register" tag="span">立即开启</router-link>在线签</li>
              </ul>
            </div>
            <div class="startList">
                <ul v-if="signLists.length>0">
                  <li v-for="(item,index) in signLists" :key="index">
                   <span><img :src="item.img"></span>
                    <p>{{item.name}}</p>
                  </li>
                </ul>
                <ul style="margin-top:60px;" v-if="signListss.length>0">
                  <li v-for="(item,index) in signListss" :key="index">
                   <span><img :src="item.img"></span>
                    <p>{{item.name}}</p>
                  </li>
                </ul>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      everList:['合作洽谈','达成意向','资质审核','客户建档','合同起草','多级审批','甲方盖章','快递邮寄','乙方盖章','快递邮寄','合同执行','归档保存'],
      deficiencyList:[
        {
          img:require('../../../assets/images/solution/dycbg_img.png'),
          name:'打印成本高'
        },
        {
          img:require('../../../assets/images/solution/wlcbg_img.png'),
          name:'物流成本高'
        },
        {
          img:require('../../../assets/images/solution/sjcbg_img.png'),
          name:'时间成本高'
        },
        {
          img:require('../../../assets/images/solution/rlcbg_img.png'),
          name:'人力成本高'
        },

        {
          img:require('../../../assets/images/solution/glczn_img.png'),
          name:'管理储存难'
        },
        {
          img:require('../../../assets/images/solution/bghb_img.png'),
          name:'不够环保'
        },
        {
          img:require('../../../assets/images/solution/other01_img.png'),
          name:'其他'
        },
      ] ,
      deficiencyLists:[
        {
          img:require('../../../assets/images/solution/htfywb_img.png'),
          name:'合同复印文本'
        },
        {
          img:require('../../../assets/images/solution/xyptsc_img.png'),
          name:'协议平台生成'
        },
        {
          img:require('../../../assets/images/solution/yhmrgx_img.png'),
          name:'用户默认勾选'
        },
        {
          img:require('../../../assets/images/solution/wkxsj_img.png'),
          name:'无可信时间'
        },
        {
          img:require('../../../assets/images/solution/wszzs_img.png'),
          name:'无数字证书'
        },
        {
          img:require('../../../assets/images/solution/wdsfcz_img.png'),
          name:'无第三方存证'
        },
        {
          img:require('../../../assets/images/solution/other02_img.png'),
          name:'其他'
        },
      ],
      signList:[
        {
          img:require('../../../assets/images/solution/smrz_icon_nor.png'),
          name:'实名认证'
        },
        {
          img:require('../../../assets/images/solution/htqs_icon_nor.png'),
          name:'合同签署'
        },
        {
          img:require('../../../assets/images/solution/qzjlcz_icon_nor.png'),
          name:'全证据链存证'
        },
        {
          img:require('../../../assets/images/solution/znhy_icon.png'),
          name:'智能合约'
        },{
          img:require('../../../assets/images/solution/lygk_icon_nor.png'),
          name:'履约管控'
        },
        {
          img:require('../../../assets/images/solution/zxgz_icon.png'),
          name:'在线公证'
        },
        {
          img:require('../../../assets/images/solution/sfjd_icon.png'),
          name:'司法鉴定'
        },
        {
          img:require('../../../assets/images/solution/lsfw_icon.png'),
          name:'律师服务'
        },
        {
          img:require('../../../assets/images/solution/zxzc_icon.png'),
          name:'在线仲裁'
        },
        {
          img:require('../../../assets/images/solution/law_icon.png'),
          name:'在线法院'
        },
      ],
      signLists:[
        {
          img:require('../../../assets/images/solution/bank_icon.png'),
          name:'银行'
        },
        {
          img:require('../../../assets/images/solution/bx_icon.png'),
          name:'保险'
        },
        {
          img:require('../../../assets/images/solution/pay_icon.png'),
          name:'第三方支付'
        },
        {
          img:require('../../../assets/images/solution/yl_icon.png'),
          name:'医疗'
        },
        {
          img:require('../../../assets/images/solution/jy_icon.png'),
          name:'在线教育'
        },
        {
          img:require('../../../assets/images/solution/kdwl_icon.png'),
          name:'快递物流'
        },
      ],
      signListss:[
        {
          img:require('../../../assets/images/solution/gyl_icon.png'),
          name:'供应链'
        },
        {
          img:require('../../../assets/images/solution/xffq_icon.png'),
          name:'消费分期'
        },
        {
          img:require('../../../assets/images/solution/qcjr_icon.png'),
          name:'汽车金融'
        },
        {
          img:require('../../../assets/images/solution/ls_icon.png'),
          name:'零售'
        },
        {
          img:require('../../../assets/images/solution/zz_icon.png'),
          name:'制造'
        },
        {
          img:require('../../../assets/images/solution/qthy_icon.png'),
          name:'其他行业'
        },
      ]
    }
  }
}
</script>
<style lang="scss" >
.othersolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
        padding-bottom:40px;
        margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
            span{
                display: inline-block;
                width: 80px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                color: #B41C2E;
                border: 2px solid #B41C2E;
                border-radius: 4px;
                border-radius: 4px;
                font-size: 12px;
                vertical-align: middle;
                margin: 0 7px;
                  }
            span:hover{
              color:#fff;
              background-color: #B41C2E;
            }
          }
        }
        .solttionConHeads{
          li{
            line-height: 30px;
          }
           li:nth-child(1){
             margin-top: 6px;
           }
        }
        .othersItem{
          width:100%;
          height: 196px;
          padding:50px 106px;
          border: 2px dashed #DCDCDC;
          box-sizing:border-box;
          ul{
            width:100%;
            height: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            li{
              width:100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              position: relative;
              span{
                display: block;
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background: #B41C2E;
                font-size: 12px;
                color: #FFFFFF;
                position: relative;
                border-radius: 50%;
              }
              span:after{
                content: '';
                position: absolute;
                display: block;
                width: 61px;
                top: 8px;
                right: 20px;
                height: 2px;
                background: #B41C2E;
              }
              p{
                 font-size: 16px;
                color: #787878;
              }
            }
            li:last-child{
              span:before{
                content: '';
                position: absolute;
                display: block;
                width: 61px;
                top: 8px;
                right: -59px;
                height: 0px;
                border:1px dashed #B41C2E
              }
            }
            li:nth-child(2n-1){
              p{
                position: absolute;
                bottom:0;
              }
            }
            li:nth-child(2n){
              p{
                position: absolute;
                top:0;
              }
            }
            li:nth-child(2n-1):after{
              content: '';
              display: block;
              width:2px;
              height: 9px;
              background: #B41C2E;
              position: absolute;
              bottom:27px;
              left:50%;
              margin-left:-1px;
            }
            li:nth-child(2n):before{
              content: '';
              display: block;
              width:2px;
              height: 9px;
              background: #B41C2E;
              position: absolute;
              top:27px;
              left:50%;
              margin-left:-1px;
            }
          }
        }
        .signItem{
          width:100%;
          padding-top: 20px;
          ul{
             width:100%;
            height: 100%;
            display: flex;
            justify-content:space-between;
            align-items: center;
            li{
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              p{
                margin-top: 16px;
                font-size: 16px;
                color: #787878;
              }
            }
          }
        }
        .startList{
          padding-top:40px;
          width:100%;
            ul{
              width:100%;
              height: 100%;
              display: flex;
              justify-content:space-between;
              align-items: center;
              li{
                width:160px;
                height: 80px;
                border: 1px solid #C8C8C8;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                position: relative;
                span{
                  margin-top:-20px;
                  background: #fff;
                  padding:0 30px;
                  img{
                    height: 33px;
                  }
                }
                span:hover img{
                  animation: tada 1.5s ease infinite;
                }
                p{
                  font-size: 18px;
                  margin-top: 14px;
                  color:rgb(50,50,50);
                  letter-spacing: 2px;
                }
              }
              li:after{
                content: '';
                display: block;
                position: absolute;
                height:2px;
                width: 42px;
                right: -43px;
                top: 50%;
                margin-top:-1px;
                background: #C8C8C8;
              }
              li:last-child:after{
                  width:0px;
              }
            }
            ul:first-child{
              li:first-child:before{
                content: '';
                display: block;
                position: absolute;
                height: 40px;
                width: 2px;
                bottom:-40px;
                background: #C8C8C8;
              }
              li:last-child:before{
                content: '';
                display: block;
                position: absolute;
                height: 40px;
                width: 2px;
                bottom:-40px;
                background: #C8C8C8;
              }
            }
        }
      }
    }
    .solttionConB{
      width: 100%;
      background: #F5F5F5;
      .solttionConItem{
        width:1180px;
        padding-bottom:40px;
        margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .deficiencyBox{
          width: 100%;
          ul{
            width: 100%;
            display: flex;
            justify-content:space-between;
            align-items: center;
            li{
              width: 150px;
              height: 128px;
              text-align: center;
              background: #FCFCFC;
              border: 1px solid #EBEBEB;
              padding:4px 4px 0 4px;
              box-sizing: border-box;
              img{
                width: 140px;
                height: 80px;
              }
              p{
                font-size: 16px;
                color: #787878;
                height: 36px;
                line-height: 36px;
                letter-spacing: 1px;
              }
            }
            li:hover{
              background: #FCFCFC;
              box-shadow: 0 6px 12px 0 rgba(0,0,0,0.20);
            }
          }
          .title{
            font-size: 14px;
            color: #787878;
            margin-top: 24px;
          }
        }
      }
      .solttionConItem:nth-child(1){
        padding-bottom: 0;
      }
    }
  }
  @-webkit-keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}
</style>
